import axios from '../../utils/axios';
import { LIMIT } from '../../utils/config';
const ExercisePackageService = {

  async getListExercisePackages(page = 1, limit = LIMIT, search = '') {
    try {
      const response = await axios.get('/admin/exercise-packages', {
        params: {
          page,
          limit,
          search,
        }
      })
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async getById(id) {
    try {
      const response = await axios.get(`/exercise-packages/${id}`);
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async deleteById(id) {
    try {
      const response = await axios.delete(`/admin/exercise-packages/${id}`);
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async create(model) {
    try {
      const response = await axios.post('/exercise-packages', model);
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  /**
   * Update by id
   * @param {number} id id of user
   * @param {Object} model data to update
   */
  async updateById(id, model) {
    try {
      const response = await axios.put(`/admin/exercise-packages/${id}`, model);
      return response.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
}

export default ExercisePackageService;
